import { render, staticRenderFns } from "./xwzxtop.vue?vue&type=template&id=4568e87e&scoped=true&"
import script from "./xwzxtop.vue?vue&type=script&lang=js&"
export * from "./xwzxtop.vue?vue&type=script&lang=js&"
import style0 from "./xwzxtop.vue?vue&type=style&index=0&id=4568e87e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568e87e",
  null
  
)

export default component.exports